import { render, staticRenderFns } from "./PersonInputCard.vue?vue&type=template&id=acb5156e&scoped=true"
import script from "./PersonInputCard.vue?vue&type=script&lang=js"
export * from "./PersonInputCard.vue?vue&type=script&lang=js"
import style0 from "./PersonInputCard.vue?vue&type=style&index=0&id=acb5156e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb5156e",
  null
  
)

export default component.exports